import React from 'react';
import { Code, Lightbulb } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { skills } from '../mock';

const Skills = ({ isVisible }) => {
  return (
    <section id="skills" data-section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            Skills & Expertise
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-12"></div>

          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
            {/* Technical Skills */}
            <Card className="border-2 border-slate-200 hover:border-blue-700 hover:shadow-xl transition-all duration-300">
              <CardHeader className="bg-slate-50">
                <CardTitle className="flex items-center gap-2 text-blue-900">
                  <Code size={24} className="text-blue-700" />
                  Technical Skills
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="space-y-4">
                  {skills.technical.map((skill, index) => (
                    <div key={index}>
                      <div className="flex justify-between mb-2">
                        <span className="text-slate-700 font-medium">{skill.name}</span>
                        <span className="text-blue-700 font-semibold">{skill.level}%</span>
                      </div>
                      <div className="w-full bg-slate-200 rounded-full h-2.5 overflow-hidden">
                        <div
                          className="bg-blue-700 h-2.5 rounded-full transition-all duration-1000 ease-out"
                          style={{
                            width: isVisible ? `${skill.level}%` : '0%'
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Areas of Expertise */}
            <Card className="border-2 border-slate-200 hover:border-blue-700 hover:shadow-xl transition-all duration-300">
              <CardHeader className="bg-slate-50">
                <CardTitle className="flex items-center gap-2 text-blue-900">
                  <Lightbulb size={24} className="text-blue-700" />
                  Areas of Expertise
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="flex flex-wrap gap-3">
                  {skills.expertise.map((area, index) => (
                    <Badge
                      key={index}
                      className="bg-blue-700 text-white hover:bg-blue-800 text-sm py-2 px-4 transition-colors"
                    >
                      {area}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;